module.exports = __webpack_public_path__ + "img/iceland.8aedeb30.svg";